import React from "react";
import { connect } from "react-redux";
import { toggleMenu } from "../../../actions";
import NavItems from "../navitems";
import SocialLinks from "../social/Links";

const mapStateToProps = state => {
  return { sidemenuOn: state.sidemenuOn };
};
const mapDispatchToProps = dispatch => {
  return {
    toggleMenu: sidemenuOn => {
      dispatch(toggleMenu(sidemenuOn));
    }
  };
};
let onClick = (e, props) => {
  e.preventDefault();
  if (e.target.className.includes("btn-close")) {
    props.toggleMenu(props.sidemenuOn);
  }
};

function Sidemenu(props) {
  console.log(props);
  return (
    <div
      className={props.sidemenuOn ? "side-menu side-menu-active" : "side-menu"}
    >
      <div className="inner-wrapper">
        <span
          className="btn-close"
          id="btn_sidebar_colse"
          onClick={e => onClick(e, props)}
        />
        <nav className="side-nav width-100">
          {/* <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <a
                className="nav-link active"
                href
                onClick={onClick}
                data-scroll-nav="0"
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href
                onClick={onClick}
                data-scroll-nav="1"
              >
                About
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href
                onClick={onClick}
                data-scroll-nav="2"
              >
                Experience
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href
                onClick={onClick}
                data-scroll-nav="3"
              >
                Portfolio
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href
                onClick={onClick}
                data-scroll-nav="4"
              >
                Services
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href
                onClick={onClick}
                data-scroll-nav="5"
              >
                Blog
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href
                onClick={onClick}
                data-scroll-nav="6"
              >
                Contact
              </a>
            </li>
          </ul> */}
          <NavItems />
        </nav>

        <div className="side-footer width-100">
          <SocialLinks classname="social-links" />
        </div>
      </div>
    </div>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidemenu);
